<template>

  <VueTabs>
    <v-tab id="tab0" v-if="tab0Allowed" :title="$t('tabs.paved')">
      <PavedImportForm />
    </v-tab>

    <v-tab id="tab1" v-if="tab1Allowed" :title="$t('tabs.gravel')">
      <UnpavedImportForm />
    </v-tab>
  </VueTabs>
</template>

<script>
import { VueTabs, VTab } from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
import permissions from '@/mixins/permissionsMixin'
import PavedImportForm from './PavedImportForm.vue'
import UnpavedImportForm from './UnpavedImportForm.vue'

export default {
  name: 'ConditionImportForm',
  mixins: [permissions],

  components: {
    VueTabs,
    VTab,
    PavedImportForm,
    UnpavedImportForm
  },

  data() {
    return {
      formName: 'ConditionImportForm'
    }
  },

  mounted() {
    if (!this.checkIfScreenAllowed()) {
      this.onClose()
      return
    }
  },

  computed: {
    tab0Allowed() {
      return this.isScreenAllowed('ConditionImportForm')
    },
    tab1Allowed() {
      return this.isScreenAllowed('ConditionImportForm')
    }
  }
}
</script>

<style scoped>
.vue-tabs {
  height: 100%;
}

.vue-tabs .tab-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#p-tab0 {
  width: 60%;
}

#p-tab1 {
  width: 60%;
}

.vue-tabs .tab-content>div {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vue-tabs .nav-tabs>li.active>a,
.vue-tabs .nav-tabs>li.active>a:hover,
.vue-tabs .nav-tabs>li.active>a:focus {
  background-color: #4caf50;
}
</style>
